// Tab switching functionality
function switchTab(tabId) {
    const tabs = document.querySelectorAll('.feature-tab-content');
    const buttons = document.querySelectorAll('.tab-btn');
    
    tabs.forEach(tab => {
        tab.classList.remove('active');
        // First set display none to ensure proper transition
        tab.style.display = 'none';
        tab.style.opacity = '0';
    });
    
    buttons.forEach(button => {
        button.classList.remove('active');
    });
    
    const activeTab = document.getElementById(tabId);
    const activeButton = document.querySelector(`[data-tab="${tabId.replace('-features', '')}"]`);
    
    if (activeTab && activeButton) {
        activeTab.style.display = 'block';
        // Use setTimeout to ensure display:block is applied before transition
        setTimeout(() => {
            activeTab.style.opacity = '1';
            activeTab.classList.add('active');
        }, 10);
        activeButton.classList.add('active');
    }
}

// Pricing toggle functionality
function togglePricing() {
    const yearlyPrices = document.querySelectorAll('.price.yearly');
    const monthlyPrices = document.querySelectorAll('.price.monthly');
    const toggle = document.getElementById('pricingToggle');
    
    yearlyPrices.forEach(price => {
        price.classList.toggle('active', toggle.checked);
    });
    
    monthlyPrices.forEach(price => {
        price.classList.toggle('active', !toggle.checked);
    });
}

// FAQ accordion functionality
function toggleFAQ(element) {
    const faqItem = element.closest('.faq-item');
    const answer = element.nextElementSibling;
    const isExpanded = faqItem.classList.contains('active');
    
    // Close all other FAQs
    const allFaqItems = document.querySelectorAll('.faq-item');
    allFaqItems.forEach(item => {
        if (item !== faqItem) {
            item.classList.remove('active');
            const question = item.querySelector('.faq-question');
            question.setAttribute('aria-expanded', 'false');
        }
    });
    
    // Toggle current FAQ with smooth transition
    faqItem.classList.toggle('active');
    element.setAttribute('aria-expanded', (!isExpanded).toString());
    
    // Update ARIA attributes
    const answerId = answer.id || `faq-answer-${Math.random().toString(36).substr(2, 9)}`;
    answer.id = answerId;
    element.setAttribute('aria-controls', answerId);
}

// Industries section auto-scroll functionality
let scrollInterval;
let isScrolling = true;
let scrollContainer = null;

function startAutoScroll() {
    if (!scrollContainer) return;
    
    // Clear any existing interval
    if (scrollInterval) {
        clearInterval(scrollInterval);
    }
    
    scrollInterval = setInterval(() => {
        if (isScrolling) {
            // Smoother scrolling with larger increment
            scrollContainer.scrollLeft += 2;
            
            // Reset scroll position when reaching the end
            if (scrollContainer.scrollLeft >= (scrollContainer.scrollWidth - scrollContainer.clientWidth)) {
                // Smooth reset to beginning
                const scrollToStart = () => {
                    scrollContainer.scrollLeft -= 4;
                    if (scrollContainer.scrollLeft > 0) {
                        requestAnimationFrame(scrollToStart);
                    }
                };
                requestAnimationFrame(scrollToStart);
            }
        }
    }, 30); // Adjusted timing for smoother animation
}

function setupIndustriesScroll() {
    // Initialize scrollContainer
    scrollContainer = document.querySelector('.industries-scroll-container');
    if (!scrollContainer) return;
    
    // Start auto-scrolling
    startAutoScroll();
    
    // Pause on hover
    scrollContainer.addEventListener('mouseenter', () => {
        isScrolling = false;
    });
    
    // Resume on mouse leave
    scrollContainer.addEventListener('mouseleave', () => {
        isScrolling = true;
    });
    
    // Update View More link
    //const viewMoreBtn = document.querySelector('.view-more-btn');
    //if (viewMoreBtn) {
        //viewMoreBtn.href = 'industries.html';
    //} REMOVE // from 124-127
}

// Cleanup function to prevent memory leaks
function cleanupIndustriesScroll() {
    if (scrollInterval) {
        clearInterval(scrollInterval);
    }
    if (scrollContainer) {
        scrollContainer.removeEventListener('mouseenter', () => {
            isScrolling = false;
        });
        scrollContainer.removeEventListener('mouseleave', () => {
            isScrolling = true;
        });
    }
}

// Initialize event listeners
document.addEventListener('DOMContentLoaded', () => {
    // Initialize pricing toggle
    const pricingToggle = document.getElementById('pricingToggle');
    if (pricingToggle) {
        pricingToggle.addEventListener('change', togglePricing);
    }
    
    // Initialize FAQ accordions
    const faqQuestions = document.querySelectorAll('.faq-question');
    faqQuestions.forEach(question => {
        question.addEventListener('click', () => toggleFAQ(question));
    });
    
    // Initialize industries scroll
    setupIndustriesScroll();
});

// Cleanup on page unload
window.addEventListener('unload', cleanupIndustriesScroll);